module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/_somaliland-afaef49cab4616173186b585f4eb97ff.png";